import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { toast } from 'react-toastify';
import ReactMarkdown from 'react-markdown';

import './Instructions.css';
import { getLocalizedString } from '../../localization/LocalizedString';
import EditContactInfo from './EditContactInfo';
import Button from '../forms/Button';
import { requestDestination } from '../../actions/destination';

class Instructions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editingContactInfo: false,
    };
  }

  renderDestination() {
    const { translate, destination } = this.props;
    const { editingContactInfo } = this.state;

    if (!destination || !destination.id) {
      return null;
    }
    const { contactInfo = {} } = destination || {};
    const { name = '-', phone = '-', email = '-' } = contactInfo;

    const contactDetailsUI = editingContactInfo ? (
      <EditContactInfo
        onCancel={this.showViewContactInfo}
        onSaved={this.onContactInfoSaved}
        contactInfo={contactInfo}
        destination={destination} />
    ) : (
      <div>
        <div className="row">
          <div className="col-sm-12 text-4">{name}</div>
        </div>
        <div className="row">
          <div className="col-sm-12 text-4">{phone}</div>
        </div>
        <div className="row">
          <div className="col-sm-12 text-4">
            <a href="mailto:{email}">{email}</a>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-sm-12 col-xs-6">
            <Button onClick={this.showEditContactInfo}>{translate('destination.edit_contact_info')}</Button>
          </div>
        </div>
      </div>
    );

    return (
      <div className="instructions-section">
        <h1>{translate('destination.singular')}</h1>
        <div className="instructions-section-content">
          <div className="text-4">{destination.companyName}</div>
          <div className="text-4">{`${destination.streetAddress}, ${destination.postalCode}, ${destination.city}`}</div>
          <h3>{translate('destination.contactInfo')}</h3>
          { contactDetailsUI }
        </div>
      </div>
    );
  }

  showEditContactInfo = () => {
    this.setState({
      editingContactInfo: true,
    });
  }

  showViewContactInfo = () => {
    this.setState({
      editingContactInfo: false,
    });
  }

  onContactInfoSaved = () => {
    this.showViewContactInfo();
    const { translate, requestDestination, destination } = this.props;
    toast(translate('destination.contact_info_save_ok'));
    requestDestination(destination.id);
  }

  renderServiceSite() {
    const { serviceSite, translate, currentLanguage } = this.props;

    if (!serviceSite || !serviceSite.id) {
      return null;
    }

    return (
      <div className="instructions-section">
        <h1>{translate('service_site.singular')}</h1>
        <div className="instructions-section-content">
          <div className="text-4">{serviceSite.serviceSiteId}</div>
          <div className="text-4">{getLocalizedString(serviceSite.name, currentLanguage)}</div>
          <div className="text-4">{getLocalizedString(serviceSite.group, currentLanguage)}</div>
        </div>
      </div>
    );
  }

  renderServices() {
    const { serviceSite, translate, currentLanguage } = this.props;

    if (!serviceSite || !serviceSite.services) {
      return null;
    }

    return (
      <div className="instructions-section">
        <h1>{translate('service.plural')}</h1>
        <div className="instructions-section-content instructions-services">
          {serviceSite.services.map((service) => (
            <div key={service.id} className="instructions-service text-4">
              {getLocalizedString(service.name, currentLanguage)}
              ,
              {getLocalizedString(service.localizedRepeat, currentLanguage)}
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderInstructions() {
    const { instructions, translate, currentLanguage } = this.props;

    if (!instructions) {
      return null;
    }

    return (
      <div className="instructions-section">
        <h1>{translate('instructions')}</h1>
        <ReactMarkdown className="instructions-markdown">
          {getLocalizedString(instructions, currentLanguage)}
        </ReactMarkdown>
      </div>
    );
  }

  render() {
    const { className } = this.props;

    return (
      <div className={`instructions ${className || ''}`}>
        {this.renderDestination()}
        {this.renderServiceSite()}
        {this.renderServices()}
        {this.renderInstructions()}
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLanguage = getActiveLanguage(locale);

  return {
    translate: getTranslate(locale),
    currentLanguage: activeLanguage?.code || 'fi',
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  requestDestination,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Instructions);
